var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"stage",style:({width: _vm.width+'px', height: (_vm._height)+'px'}),attrs:{"width":_vm.width,"height":_vm._height}})}
var staticRenderFns = []

export { render, staticRenderFns }